/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from "@material-ui/core";
import React, { useContext, useState, useEffect } from "react";
import CircularProgressWithLabel from "../../../components/CircularProgressWithLabel";
import SingleSelect from "../../../components/SelectField/SingleSelect";
import { getDocCount } from "../../../services/apiservices/counters";
import { COLLECTIONS } from "../../../services/config";
import styles from "../dashboard.module.scss";
import moment from "moment/moment";
import AuthContext from "../../../hooks/authContext";
import { ReportProblem } from "@mui/icons-material";

function Issues() {
  const auth = useContext(AuthContext);
  const [iprogress, setIProgress] = useState(0);
  const [issueData, setIssueData] = useState([]);
  const [turtype, setTUrtype] = useState(0);
  const [tnrtype, setTNrtype] = useState(0);
  const [itotalno, setITotalNo] = useState(0);
  const [issuesf, setIssuesf] = useState(0);
  const [filtername, setFilterName] = useState("Urgent");
  const [status, setStatus] = useState("open");
  const [allIssues, setAllIssues] = useState([]);

  const localClientID = localStorage.getItem("clientId");
  const localCompanyId = localStorage.getItem("companyId");

  const companyId =
    auth?.userProfile?.role === "Client"
      ? localCompanyId || auth?.userProfile?.companyId
      : auth?.userProfile?.role === "companyUser"
      ? auth?.userProfile?.id
      : auth?.userProfile?.companyId;

  const clientId = localClientID || auth?.userProfile?.client;

  const statusList = [
    { label: "Open Issues", value: "open" },
    { label: "Closed Issues", value: "closed" },
  ];

  const updateIProgress = (newval) => setIProgress(newval);

  const calculateAndSetData = (data, type) => {
    const today = moment().format(moment.HTML5_FMT.DATE);
    let filtered = [];

    if (type === "open") {
      filtered = data?.filter((item) => item.status !== "Closed");
    } else {
      filtered = data?.filter(
        (item) =>
          item.status === "Closed" &&
          moment(item.updatedAt).format(moment.HTML5_FMT.DATE) === today
      );
    }

    const urgent = filtered?.filter((i) => i.priority === "High")?.length;
    const standard = filtered?.filter((i) => i.priority === "Low")?.length;
    const total = urgent + standard;

    setIssueData(filtered);
    setTUrtype(urgent);
    setTNrtype(standard);
    setITotalNo(total);
    setIssuesf(urgent);
    setFilterName("Urgent");

    const ratio = total > 0 ? (urgent / total) * 100 : 0;
    updateIProgress(ratio);
  };

  const onChangeInput = (e) => {
    const value = e.target.value;
    setStatus(value);
    calculateAndSetData(allIssues, value);
  };

  useEffect(() => {
    getDocCount(
      COLLECTIONS.ISSUES,
      (res) => {
        const data = res?.filter(
          (item) =>
            item.companyId === companyId &&
            (auth?.userProfile?.role !== "Client" ||
              item?.client?.id === clientId)
        );
        setAllIssues(data);
        calculateAndSetData(data, "open");
      },
      (resError) => {
        console.log("reserror", resError);
      }
    );
  }, []);

  return (
    <>
      <Grid item xs={12} sm={7} lg={12} className="mb-20">
        <div className="d-flex flex-center mb-10">
          <ReportProblem style={{ color: "rgba(59, 130, 246, 1)" }} />
          <p className="p-0 m-0 ml-10 fonthe dark:text-white">Issues</p>
        </div>

        <div
          style={{
            marginBottom: "10px",
            width: "100%",
            border: "1px solid #E2E8F0",
          }}
        ></div>

        <SingleSelect
          value={status}
          className={`field newonr`}
          name={"status"}
          onChange={(e) => onChangeInput(e)}
          options={statusList}
        />
      </Grid>

      <ul>
        <li className={styles.listItem2}>
          <Grid container spacing={1}>
            <Grid item xs={6} sm={9} className="text-gray-500 dark:text-gray-100">
              Standard Issues
            </Grid>
            <Grid item xs={6} sm={3} className="text-right dark:text-[#94A3B8]">
              <strong>{tnrtype ?? 0}</strong>
            </Grid>
          </Grid>
        </li>
        <li className={styles.listItem2}>
          <Grid container spacing={1}>
            <Grid item xs={6} sm={9} className="text-gray-500 dark:text-gray-100">
              Urgent Issues
            </Grid>
            <Grid item xs={6} sm={3} className="text-right dark:text-[#94A3B8]">
              <strong>{turtype ?? 0}</strong>
            </Grid>
          </Grid>
        </li>
      </ul>

      <Grid item xs={12} sm={5} lg={12} className="mt-40">
        <CircularProgressWithLabel
          signt={"yes"}
          value={iprogress}
          wrapclass="#2d7bf4"
          title={"Urgent Issue Ratio"}
        />
      </Grid>
    </>
  );
}

export default Issues;
